var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#94A3B8",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 16.6668C9.08887 16.6668 8.22776 16.4918 7.41665 16.1418C6.60554 15.7918 5.8972 15.3141 5.29165 14.7085C4.68609 14.1029 4.20831 13.3946 3.85831 12.5835C3.50831 11.7724 3.33331 10.9113 3.33331 10.0002C3.33331 9.07794 3.50831 8.21405 3.85831 7.4085C4.20831 6.60294 4.68609 5.89738 5.29165 5.29183C5.8972 4.68627 6.60554 4.2085 7.41665 3.8585C8.22776 3.5085 9.08887 3.3335 9.99998 3.3335C10.9222 3.3335 11.7861 3.5085 12.5916 3.8585C13.3972 4.2085 14.1028 4.68627 14.7083 5.29183C15.3139 5.89738 15.7916 6.60294 16.1416 7.4085C16.4916 8.21405 16.6666 9.07794 16.6666 10.0002C16.6666 10.9113 16.4916 11.7724 16.1416 12.5835C15.7916 13.3946 15.3139 14.1029 14.7083 14.7085C14.1028 15.3141 13.3972 15.7918 12.5916 16.1418C11.7861 16.4918 10.9222 16.6668 9.99998 16.6668ZM9.99998 14.0002C11.1111 14.0002 12.0555 13.6113 12.8333 12.8335C13.6111 12.0557 14 11.1113 14 10.0002C14 8.88905 13.6111 7.94461 12.8333 7.16683C12.0555 6.38905 11.1111 6.00016 9.99998 6.00016C8.88887 6.00016 7.94442 6.38905 7.16665 7.16683C6.38887 7.94461 5.99998 8.88905 5.99998 10.0002C5.99998 11.1113 6.38887 12.0557 7.16665 12.8335C7.94442 13.6113 8.88887 14.0002 9.99998 14.0002Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoCircle);
export default __webpack_public_path__ + "static/media/todoCircle.78d79f883772767d68d844350df534e8.svg";
export { ForwardRef as ReactComponent };